import {ZeroBet} from "@nolimitcity/slot-game/bin/timelinegameround/game/gameround/presentations/ZeroBet";
import {BalanceEvent} from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Timeline, TimelineLite} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";


export class BuffaloZeroBet extends ZeroBet {
    constructor() {
        super();
    }

    public getAnimation(data:ParsedServerData):Timeline {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            EventHandler.dispatchEvent(new GameEvent(BalanceEvent.ZERO_BET, data.freespinsLeft-1));
        }, 0.5);
        return tl;
    }

}